import {ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit, Optional, PLATFORM_ID} from '@angular/core';
import {Driver, FarmOut, JobEvent, Service, User, Vehicle} from '../../../../models/business-objects';
import {BehaviorSubject, firstValueFrom, Subject} from 'rxjs';
import {JobService} from '../../../services/job.service';
import {TranslateService, TranslateModule} from '@ngx-translate/core';
import {MatDialog, MatDialogRef, MatDialogModule} from '@angular/material/dialog';
import {CanonicalAndMetaService} from '../../../services/canonical-and-meta.service';
import {ActivatedRoute, RouterModule} from '@angular/router';
import {AuthService} from '../../../services/auth.service';
import {ProviderService} from '../../../services/provider.service';
import {CountryISO, SearchCountryField, NgxIntlTelInputModule} from 'ngx-intl-tel-input';
import {FormControl, UntypedFormBuilder, UntypedFormGroup, Validators, ReactiveFormsModule, FormsModule} from '@angular/forms';
import {MapPopupComponent} from '../../../widget/map-popup/map-popup.component';
import {JobMapComponent} from '../../job/job-map/job-map.component';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {LocalizeRouterModule} from '@gilsdav/ngx-translate-router';
import {NgSelectModule} from '@ng-select/ng-select';
import {CurrencyFormatterDirective} from '../../../shared/directives/CurrencyFormatterDirective';
import {AsyncPipe} from '@angular/common';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.css'],
  standalone: true,
  imports: [
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    TranslateModule,
    NgxIntlTelInputModule,
    MapPopupComponent,
    JobMapComponent,
    LocalizeRouterModule,
    NgSelectModule,
    CurrencyFormatterDirective,
    AsyncPipe
  ]
})
export class ConfirmComponent implements OnInit, OnDestroy {
  private token: string;
  farmOut: FarmOut = new FarmOut();
  private subscriptions = [];
  drivers : BehaviorSubject<Driver[]> = new BehaviorSubject ([]);
  driver : Driver;
  vehicles: BehaviorSubject<Vehicle[]> = new BehaviorSubject ([]);
  vehicle : Vehicle;
  jwtUser: User;
  farmOutId: string;
  loadingDetails: BehaviorSubject <boolean> = new BehaviorSubject (true);
  quoteLocked: BehaviorSubject <boolean> = new BehaviorSubject (true);
  asignationLocked: BehaviorSubject <boolean> = new BehaviorSubject (true);
  billingInfoLocked: BehaviorSubject <boolean> = new BehaviorSubject (true);
  refLocked : BehaviorSubject<boolean> = new BehaviorSubject (true);
  farmOutForm: UntypedFormGroup;
  result: string;
  resultClass: string;
  resultString: string;
  summary: string;
  title: BehaviorSubject<string>= new BehaviorSubject ("Farmout Request");
  constructor(private providerService: ProviderService, private translate: TranslateService, public dialog: MatDialog,
              @Optional() private dialogRef: MatDialogRef<ConfirmComponent>,
              private canonicalAndMetaService: CanonicalAndMetaService, @Inject(PLATFORM_ID) private platformId: any ,private formBuilder: UntypedFormBuilder,
              private route: ActivatedRoute, private ref: ChangeDetectorRef, private authService: AuthService) {
    this.translate.setDefaultLang('en');
    this.token = this.route.snapshot.paramMap.get('token');
    this.farmOutId = this.route.snapshot.paramMap.get('ref');
    if(authService.currentUserValue!= null && authService.currentUserValue.proveedorId != null ) {
      if (this.farmOut!= null) {
        (this.providerService.getVehicles(this.farmOut.ciudad).then(data => {
          let data2: Vehicle[] = [{id: -1, plate: 'Manual Selection', categoryId: undefined, makeModel :""}]
          data2.push(...data);
          this.vehicles.next(data2);
        }).catch( reason => []));
        (this.providerService.getDrivers(this.farmOut.ciudad).then(data => {
          let data2: Driver[] = [{id: -1, firstName: "Manual", lastName: " Selection", celular: undefined}]
          data2.push(...data);
          this.drivers.next( data2);
        }).catch( reason => []));
      } else {
        (this.providerService.getVehicles("").then(data => {
          let data2: Vehicle[] = [{id: -1, plate: 'Manual Selection', categoryId: undefined, makeModel :""}]
          data2.push(...data);
          this.vehicles.next(data2);
        }).catch( reason => []));
        (this.providerService.getDrivers("").then( data =>  {
          let data2 : Driver[] = [{id :-1, firstName: "Manual", lastName: " Selection", celular: undefined }]
          data2.push(...data);
          this.drivers.next(data2);
        }).catch( reason => []));
      }
    } else if (this.token != null) {
      (this.providerService.getVehiclesFromJWT(this.token).then(data => {
        let data2: Vehicle[] = [{id: -1, plate: 'Manual Selection', categoryId: undefined, makeModel :""}]
        data2.push(...data);
        this.vehicles.next(data2);
      }).catch( reason => []));
      (this.providerService.getDriversFromJWT(this.token).then(data => {
        let data2: Driver[] = [{id: -1, firstName: "Manual", lastName: " Selection", celular: undefined}]
        data2.push(...data);
        this.drivers.next(data2);
      }).catch( reason => []));
    }


  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subs => subs.unsubscribe());
  }

  async ngOnInit() {
    await this.canonicalAndMetaService.setCanonicalURL('confirm').then(async result => {
      await this.canonicalAndMetaService.setMetas('confirm', true, '');
    });
    this.subscriptions.push(this.authService.currentUser.subscribe(async user => {
      await this.initJob();
      console.log(this.route.snapshot.url);
      console.log('datos confirm inicializados');
      this.formatResult()
    }));
    this.subscriptions.push(this.vehicles.asObservable().subscribe( data => {
      // if (this.farmOut) {
      //   this.vehicles.next(this.vehicles.value.filter(v => v.ciudadWeb = this.farmOut.ciudad))
      // }
      this.ref.detectChanges();
    }));
    this.subscriptions.push(this.drivers.asObservable().subscribe( data => {
      // if (this.farmOut) {
      //   this.drivers.next(this.drivers.value.filter(v => v. = this.farmOut.ciudad))
      // }
      this.ref.detectChanges();
    }));
  }

  buildFormGroup (){
    this.farmOutForm = this.formBuilder.group({
      driverPhone: [this.farmOut.driverPhone],
    });
    if (this.farmOut == null || this.farmOut.driverId == null) {
      this.farmOutForm.controls.driverPhone.enable() ;
    } else {
      this.farmOutForm.controls.driverPhone.disable() ;
    }
  }

  formatResult() {
    // aca si this.result no esta vacio eso quiere decir que hubo un error en una etapa anterior
    if (this.result === '') {
      console.log('result esta vacio lo llenamos');
      if (this.farmOut) {
        this.summary = "Esta reserva esta en proceso de solicitud por parte de nuestro cliente gracias por ayudarnos a confirmarla ofreciéndonos su mejor servicio";
        if (this.farmOut.selected) {
          this.summary = "Esta reserva esta confirmada, completar la informacion para poder comunicarla al pasajero principal"
        }
        this.ref.detectChanges();
      } else {
        this.result = 'Error : Servicio nulo';
        this.ref.detectChanges();
      }
    } else {
      console.log('result no esta vacio');
    }
  }
  async initJob() {
    this.loadingDetails.next(true);
    this.result = '';
    this.resultString = '';
    if (this.token) {
      console.log('token encontrado ' + this.token );
      console.log(this.route.snapshot.paramMap);
      await this.providerService.getServiceToConfirm(this.token).then(data => {
        console.log('respuesta reserva jwt');
        console.log(data);
        try {
          this.farmOut = data.farmOut;
          this.updateVisibility();
          this.jwtUser = data.user;
          //this.authService.currentUserValue = this.jwtUser;
          // no se debe sobre escribir el usuario logeado ni logear a nadie con un link
          this.loadingDetails.next(false);
          this.result = '';
          this.ref.detectChanges();
        } catch (error) {
          try {
            this.result = data.error;
            this.loadingDetails.next(false);
            this.farmOut = null;
            console.log('respuesta  ' + this.result );
            this.ref.detectChanges();
          } catch (error) {
            this.loadingDetails.next(false);
            this.farmOut = null;
            console.log('respuesta al jwt invalida ');
            console.log(error);
            this.result = 'respuesta al jwt invalida';
            this.ref.detectChanges();
          }
        }
      }, error => {
        this.loadingDetails.next(false);
        console.log('respuesta al jwt invalida ');
        console.log(error);
        this.farmOut = null;
        this.result = 'Asegurese que el farmout este activo.<br />' +
          'O que no haya sido ya contestado';
        this.ref.detectChanges();
      });
    } else if (this.authService.currentUserValue != null && this.farmOutId){
      console.log('sin token encontrado pero con usuario' + this.authService.currentUserValue );
      console.log(this.route.snapshot.paramMap);
      this.getFarmoutById();
    } else {
      if (!this.farmOutId) {
        this.result = 'Url incompleta, por favor averiguar que la copio bien o solicitar que se la vuelvan a enviar';
      }
      this.ref.detectChanges();
      console.log('no jwt encontrado');
      this.loadingDetails.next(false);
    }
  }

 async quoteJob() {
   this.farmOutForm.markAllAsTouched();
   this.resultString = '';
   if (this.farmOutForm.valid || this.farmOutForm.disabled) {
     this.result = '';
     this.farmOut.status = 'QUOTED';
     console.log('Job quoted:', this.farmOut.jobId);
     await this.sendFarmoutBack();
   } else {
     this.resultClass = 'alert alert-danger';
     firstValueFrom(this.translate.get('app.profile.Profile-19')).then(text => {
       this.resultString = text ;
     });
   }
 }

  async acceptJob(accept:boolean) {
    this.farmOutForm.markAllAsTouched();
    this.resultString = '';
    if (this.farmOutForm.valid || this.farmOutForm.disabled) {
      this.result = '';
      // Logic for accepting the job
      if (accept) {
        this.farmOut.status = 'ACCEPTED';
      }
      console.log('Job Accepted:', this.farmOut.jobId);
      await this.sendFarmoutBack();
    } else {
      console.log('Job not accepted:', this.farmOutForm.status);
      this.resultClass = 'alert alert-danger';
      firstValueFrom(this.translate.get('app.profile.Profile-19')).then(text => {
        this.resultString = text ;
      });
    }
  }
  async getFarmoutById() {
    this.loadingDetails.next(true);
    await this.providerService.getServiceToConfirmById(Number(this.farmOutId),null, null, null, null, null, null).then(data => {
      console.log('respuesta reserva jwt');
      console.log(data);
      try {
        this.farmOut = data;
        this.updateVisibility();
        this.jwtUser = null;
        //this.authService.currentUserValue = this.jwtUser;
        // no se debe sobre escribir el usuario logeado ni logear a nadie con un link
        this.loadingDetails.next(false);
        this.result = '';
        this.ref.detectChanges();
      } catch (error) {
        try {
          this.result = error.error;
          this.loadingDetails.next(false);
          this.farmOut = null;
          console.log('respuesta  ' + this.result );
          this.ref.detectChanges();
        } catch (error) {
          this.loadingDetails.next(false);
          this.farmOut = null;
          console.log('respuesta a la solicitud con usuario invalida ');
          console.log(error);
          this.result = 'respuesta a la solicitud con usuario invalida';
          this.ref.detectChanges();
        }
      }
    }, error => {
      this.loadingDetails.next(false);
      console.log('respuesta a la solicitud con usuario invalida ');
      console.log(error);
      this.farmOut = null;
      this.result = 'Asegurese que el farmout este activo.<br />' +
        'O que no haya sido ya contestado';
      this.ref.detectChanges();
    });
  }

  async rejectJob() {
    this.farmOutForm.markAllAsTouched();
    this.resultString = '';
    if (this.farmOutForm.valid || this.farmOutForm.disabled) {
      console.log('Job rejected:', this.farmOut.jobId);
      this.result = '';
      this.farmOut.status = 'REJECTED';
      await this.sendFarmoutBack()
    } else {
      this.resultClass = 'alert alert-danger';
      firstValueFrom(this.translate.get('app.profile.Profile-19')).then(text => {
        this.resultString = text ;
      });
    }
  }

  async sendInvoice() {
    this.farmOutForm.markAllAsTouched();
    this.resultString = '';
    if (this.farmOutForm.valid || this.farmOutForm.disabled) {
      console.log('Job invoice sent:', this.farmOut.jobId);
      this.result = '';
      await this.sendFarmoutBack()
    } else {
      this.resultClass = 'alert alert-danger';
      firstValueFrom(this.translate.get('app.profile.Profile-19')).then(text => {
        this.resultString = text ;
      });
    }
  }

  async sendFarmoutBack (){
    if (this.farmOutForm.controls.driverPhone.value) {
      this.farmOut.driverPhone = this.farmOutForm.controls.driverPhone.value.internationalNumber;
    }
    if (this.farmOut.allInclusivePrice ) this.farmOut.allInclusivePrice = Number( this.unformatNumber(this.farmOut.allInclusivePrice.toString()))
    if (this.farmOut.aditionalHourPrice ) this.farmOut.aditionalHourPrice = Number( this.unformatNumber(this.farmOut.aditionalHourPrice.toString()))
    this.loadingDetails.next(true);
    await this.providerService.getFarmoutUpdate(this.token, this.farmOut).then(data => {
      console.log('respuesta sendFarmoutBack');
      console.log(data);
      try {
        this.farmOut = data.farmOut;
        this.updateVisibility();
        this.loadingDetails.next(false);
        this.result = '';
        this.ref.detectChanges();
      } catch (error) {
        try {
          this.result = data.error;
          this.loadingDetails.next(false);
          this.farmOut = null;
          console.log('respuesta  ' + this.result);
          this.ref.detectChanges();
        } catch (error) {
          this.loadingDetails.next(false);
          this.farmOut = null;
          console.log('respuesta sendFarmoutBack invalida ');
          console.log(error);
          this.result = 'respuesta sendFarmoutBack invalida';
          this.ref.detectChanges();
        }
      }
    }, error => {
      this.loadingDetails.next(false);
      console.log('respuesta sendFarmoutBack invalida ');
      console.log(error);
      this.farmOut = null;
      this.result = 'Asegurese que el farmout este activo.<br />' +
        'O que no haya sido ya contestado';
      this.ref.detectChanges();
    });
  }


  updateVisibility(){
    if (this.farmOut == null) {
      console.log('unpdating visibility without farmout ');
      this.quoteLocked.next(true);
      this.asignationLocked.next(true);
      this.billingInfoLocked.next(true);
      this.refLocked.next(true);
      this.buildFormGroup()
    } else {
      console.log('unpdating visibility with farmout ');
      console.log(this.farmOut);
      this.quoteLocked.next(this.farmOut.status != 'SOLICITADO' && this.farmOut.status != 'COTIZADO');
      this.asignationLocked.next(this.farmOut.status == 'HECHO' || this.farmOut.status == 'ANULADO' || this.farmOut.status == 'FACTURADO' || this.farmOut.status == 'PAGADO');
      this.billingInfoLocked.next(this.farmOut.status == 'HECHO');
      this.refLocked.next(this.farmOut.operatorRef != null && this.farmOut.operatorRef.length > 0);
      if(this.farmOut.driverId != null && this.drivers.value){
        this.driver = this.drivers.value.filter(item => item.id === this.farmOut.driverId)[0];
      }
      if(this.farmOut.vehicleId != null && this.vehicles.value){
        this.vehicle = this.vehicles.value.filter(item => item.id === this.farmOut.vehicleId)[0];
      }
      this.buildFormGroup()
    }
    console.log(this.quoteLocked.getValue());
    console.log(this.asignationLocked.getValue());
    console.log(this.billingInfoLocked.getValue());
  }

  protected readonly CountryISO = CountryISO;
  protected readonly SearchCountryField = SearchCountryField;

  driverSelect() {
    console.log("changing driver");
    console.log(this.driver.lastName);
    if (this.driver != null) {
      if (this.driver.id == -1) {
        this.driver = null;
        this.farmOut.driverName = null;
        this.farmOut.driverPhone =null;
        this.farmOut.driverId = null;
        this.buildFormGroup ();
        return;
      }
      this.farmOut.driverName = this.driver.firstName + " " + this.driver.lastName ;
      if (this.driver.celular != null && this.driver.celular.length > 0) {
        console.log(this.driver.celular);
        this.farmOut.driverPhone = this.driver.celular;
      } else {
        console.log(this.driver.phone);
        this.farmOut.driverPhone = this.driver.phone;
      }
      this.farmOut.driverId = this.driver.id;
      this.buildFormGroup ();
    } else {
      this.farmOut.driverName = null;
      this.farmOut.driverPhone =null;
      this.farmOut.driverId = null;
      this.buildFormGroup ();
    }
  }
  vehicleSelect() {
    console.log("changing vehicle");
    console.log(this.vehicle);
    if (this.vehicle != null) {
      if (this.vehicle.id == -1) {
        this.vehicle = null;
        this.farmOut.vehicleMakeModel = null;
        this.farmOut.vehiclePlate = null;
        this.farmOut.vehicleYear =null;
        this.farmOut.vehicleId = null;
        return;
      }
      this.farmOut.vehicleMakeModel = this.vehicle.makeModel;
      this.farmOut.vehiclePlate = this.vehicle.plate;
      this.farmOut.vehicleYear = this.vehicle.year;
      this.farmOut.vehicleId = this.vehicle.id;
    } else {
      this.farmOut.vehicleMakeModel = null;
      this.farmOut.vehiclePlate = null;
      this.farmOut.vehicleYear =null;
      this.farmOut.vehicleId = null;
    }
  }
  unformatNumber(v: string) : string {
    if (v) {
      // Create a number formatter
      const userLocale = navigator?.language || 'en-US';
      const formatter = new Intl.NumberFormat(userLocale);


      // Format a number and convert it to a string
      const formattedNumber = formatter.format(12345.67);

      // Extract the decimal separator from the formatted string
      const parts = formattedNumber.split('12345');
      const thousandSeparator = parts[1]?.charAt(0) ?? '';

      // Determine the decimal separator by formatting a number with decimals
      const decimalParts = (12345.67).toLocaleString(userLocale).split('12345');
      const decimalSeparator = decimalParts[1]?.charAt(0) ?? '';

      const paseableNumber=  v.replace(new RegExp(`[^0-9${thousandSeparator}]`, 'g'), '');
      return paseableNumber.replace(new RegExp(`[^0-9${decimalSeparator}]`, 'g'), '.');
    }
    return null;
  }


  onNoClick() {
    this.dialogRef.close(true);
  }
  @Input()
  set overrideFarmout(farmOut: FarmOut) {
    this.farmOutId = farmOut.id.toString();
    this.initJob();
  }
}
